<template>
  <div class="row pt-1" v-if="berechtigungen.m_timereporting.read">
    <div class="col-lg-12">
      <div class="tile-categorie-frame">
        <div class="tile-categorie">
          <div class="header">
            <span>{{ $t("dashboard.timereporting") }}</span>
          </div>
          <div class="body">
            <div class="row">
              <div :class="kachelCol">
                <div class="tile-frame h-1" :class="kachelStyle">
                  <router-link to="/zeiterfassung/zeitblaetter">
                    <div class="tile bg-bright-orange inverted">
                      <div class="icon-container fa-container">
                        <font-awesome-icon
                          icon="fa-duotone fa-calendar-day"
                          transform="shrink-2"
                        />
                      </div>
                      <div class="title">
                        {{ $t("dashboard.timesheets") }}
                      </div>
                    </div>
                  </router-link>
                </div>
              </div>
              <div :class="kachelKleinCol">
                <div class="tile-frame h-1" :class="kachelKleinStyle">
                  <router-link to="/zeiterfassung/uebersicht">
                    <div class="tile bg-bright-orange inverted">
                      <div class="icon-container fa-container">
                        <font-awesome-icon
                          icon="fa-duotone fa-calendar-day"
                          transform="shrink-2"
                        />
                      </div>
                      <div class="title">
                        {{ $t("dashboard.monthsheet") }}
                      </div>
                    </div>
                  </router-link>
                </div>
              </div>
              <div :class="kachelKleinCol">
                <div class="tile-frame h-1" :class="kachelKleinStyle">
                  <router-link to="/zeiterfassung/projektuebersicht">
                    <div class="tile bg-bright-orange inverted">
                      <div class="icon-container fa-container">
                        <font-awesome-icon
                          icon="fa-duotone fa-calendar-day"
                          transform="shrink-2"
                        />
                      </div>
                      <div class="title">
                        {{ $t("dashboard.projectoverview") }}
                      </div>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "StartseiteZeiterfassung",
  components: {},
  mixins: [],
  props: {
    kachelStyle: { type: String },
    kachelCol: { type: String },
    kachelKleinStyle: { type: String },
    kachelKleinCol: { type: String },
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {},
};
</script>
